
import { fieldIsInvalid, fieldIsRequired, getValidationResult } from 'shared/utils/tools'

import uuid from 'uuid/v4'
import * as yup from 'yup'

export const checkInFieldsSchema = yup.object().shape({
  isAllowed: yup.boolean(),
  isCheckedInAlready: yup.boolean(),
})

export type CheckInFieldsType = yup.InferType<typeof checkInFieldsSchema>

export function getEmptyCheckinFields(): CheckInFieldsType {
  return {
    isAllowed: false,
    isCheckedInAlready: false,
  }
}

export default function validator(data: CheckInFieldsType) {
  return getValidationResult(data, checkInFieldsSchema)
}
